import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepColor extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Color: Resource Representations</h1>
				<h2>Color</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> ID of the color </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_name </td>
							<td> String </td>
							<td> The name of the color  </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_code </td>
							<td> String </td>
							<td> HTML color code of this color  </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_type </td>
							<td> String </td>
							<td> The name of the color group that this color belongs to  </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "color_id":10,
    "color_name":"Dark Gray",
    "color_code":"6b5a5a",
    "color_type":"Solid" 
}`}</Highlight>
			</section>
		);
	}
}